import { render, staticRenderFns } from "./StockReport.vue?vue&type=template&id=2a2c1ff4&scoped=true"
import script from "./StockReport.vue?vue&type=script&lang=js"
export * from "./StockReport.vue?vue&type=script&lang=js"
import style0 from "./StockReport.vue?vue&type=style&index=0&id=2a2c1ff4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2c1ff4",
  null
  
)

export default component.exports